import React, {useRef, useState, useContext} from 'react'
import './ContactMe.css'
import emailjs from '@emailjs/browser'
import {themeContext} from '../../Context'
import {motion} from 'framer-motion'

function ContactMe() {
  const transition = {duration: 2, type: 'spring'}
  const theme = useContext(themeContext)
  const darkMode = theme.state.darkMode
    const [done, setDone] = useState(false);
  const form = useRef();
  const sendEmail = (e) => {
    e.preventDefault();
    emailjs.sendForm('service_1c1efpf', 'template_32x2rye', form.current, 'VMOY8UTRdNAWus1ng')
      .then((result) => {
          console.log(result.text);
          setDone(true)
      }, (error) => {
          console.log(error.text);
      });
  }
  return (
    <div className="contact-form" id='ContactMe'>
        <div className="w-left">
            <div className="awesome">
                <span style={{color: darkMode ? 'white' : ''}}>Get In Touch</span>
                <br />
                <span>Contact me.</span>
                <div className='blur c-blur1'
                style={{background: '#ABf1FF94'}}>
                </div>
            </div>
        </div>
        <motion.div
        initial={{left: '14rem'}}
        whileInView={{left: '0rem'}}
        transition={transition}
        className="c-right">
            <form ref={form} onSubmit={sendEmail}>
                <input
                type="text" name='user_name' className='user' placeholder='Name' required autoComplete='off' />
                <input type="email" name='user_email' className='user' placeholder='Email' required autoComplete='off' />
                <textarea name="message" className='user' placeholder='message'></textarea>
                <input type="submit" value='Send' className='button' />
                {done && "Thanks for contacting me!"}
                <div
                className='blur c-blur2'
                style={{background: "var(--purple)"}}>

                </div>
            </form>
        </motion.div>
    </div>
  )
}

export default ContactMe